import script from "./DroneMapping.vue?vue&type=script&setup=true&lang=js"
export * from "./DroneMapping.vue?vue&type=script&setup=true&lang=js"

import "./DroneMapping.vue?vue&type=style&index=0&id=80676c02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80676c02"]])

export default __exports__